import {NgModule} from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { TranslatePipe, TranslateDirective } from "@ngx-translate/core";
import { GuestsPage } from './pages/guests/guests.page';
import { GuestFiltersComponent } from './components/guest-filters/guest-filters.component';
import { GuestListComponent } from './components/guest-list/guest-list.component';
import { AccessControlPage } from './pages/access-control/access-control.page';
import { AccessControlGlobalChartComponent } from './components/access-control-global-chart/access-control-global-chart.component';
import { AccessControlDailyChartComponent } from './components/access-control-daily-chart/access-control-daily-chart.component';
import { AccessControlListComponent } from './components/access-control-list/access-control-list.component';
import { GuestAccessStatusTagComponent } from './components/guest-access-status-tag/guest-access-status-tag.component';
import { GuestAccessStatusPipe } from './pipes/guest-access-status.pipe';
import { GuestAccessStatusColorPipe } from './pipes/guest-access-status-color.pipe';
import { GuestConfirmationStatusTagPipe } from './pipes/guest-confirmation-status-tag.pipe';
import { GuestComponent } from './components/guest/guest.component';
import { GuestConfirmationStatusTagComponent } from './components/guest-confirmation-status-tag/guest-confirmation-status-tag.component';
 
import { AccreditationComponent } from './components/accreditation/accreditation.component';
import { GuestZoneInfoComponent } from './components/guest-zone-info/guest-zone-info.component';
import { GuestGroupFullnamePipe } from './pipes/guest-group-fullname.pipe';
import { GuestInvitationMailStatusComponent } from './components/guest-invitation-mail-status/guest-invitation-mail-status.component';
import { GuestMailingStatusIconComponent } from './components/guest-mailing-status-icon/guest-mailing-status-icon.component';
@NgModule({
    imports: [
        SharedModule,
        TranslatePipe,
        TranslateDirective
    ],
    declarations: [
        GuestsPage,
        AccessControlPage,
        GuestFiltersComponent,
        GuestListComponent,
        AccessControlGlobalChartComponent,
        AccessControlDailyChartComponent,
        AccessControlListComponent,
        GuestComponent,
        GuestAccessStatusTagComponent,
        GuestAccessStatusPipe,
        GuestAccessStatusColorPipe,
        GuestConfirmationStatusTagPipe,
        GuestConfirmationStatusTagComponent,
        GuestInvitationMailStatusComponent,
        AccreditationComponent,
        GuestZoneInfoComponent,
        GuestGroupFullnamePipe,
        GuestMailingStatusIconComponent
    ],
    exports: [
        GuestsPage,
        AccessControlPage
    ],
    providers: [
        GuestAccessStatusPipe,
        GuestAccessStatusColorPipe,
        GuestConfirmationStatusTagPipe,
        GuestGroupFullnamePipe
    ]
})
export class EventsModule {
    constructor() { }
}